module.exports = __webpack_public_path__ + "static/media/Library.9acef8f4.svg";